/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'

import { getBlobStorage } from '../../../assets/ts/data/data'
import { LIST_NAME } from '../../../assets/ts/data/site-feedback'
import { openFile } from '../../../assets/ts/files/files'
import { DocumentIconNames, exportToExcel } from '../../../assets/ts/general/general'
import Buttons from '../../../components/buttons/buttons'
import PageOverlayBusy from '../../../components/page-overlay/page-overlay-busy'
import useSiteFeedback from '../../../hooks/use-site-feedback'
import { SettingsHeader } from '../../../layouts/header/settings-header'
import NO_RESULTS from '../../../utils/constants/no-results'

interface Attachment {
  blobs: {
    fileName: string
    folderName: string
    metadata: { [s: string]: unknown } | ArrayLike<unknown>
  }[]
  itemKey: string
}
interface ExportColumns {
  header: string
  key: string
}
interface SiteFeedBack {
  Attachments: Attachment[]
  Description: string
  FeedbackAbout: string
  FileNames?: string[]
  Modified: string
  Title: string
  archived: string
  attachment: string
  eKey: string
  eTag: string
}

const SiteFeedback = (props: any) => {
  const { siteFeedback } = useSiteFeedback({
    orderBy: 'ItemCreated',
  })
  const [showPageOverlay, setShowPageOverlay] = useState(false)
  const [siteFeedBackItems, setsiteFeedBackItems] = useState<SiteFeedBack[]>([])
  useEffect(() => {
    async function getFeedBacks() {
      if (siteFeedback.length > 0) {
        setShowPageOverlay(true)
        await getBlobStorage(LIST_NAME, siteFeedback).then((data) => {
          const feedbacks =
            data?.map((feedBack) => ({
              Attachments: feedBack.Attachments,
              Description: feedBack.Description,
              FeedbackAbout: feedBack.FeedbackAbout,
              FileNames:
                feedBack.Attachments[0]?.blobs.map((blob) => blob.fileName).join(',') || '-',
              Modified: ` ${feedBack.ItemModifiedBy.properties.defaultDisplay} |  ${new Date(
                feedBack.ItemModified as string
              )
                .toISOString()
                .substring(0, 10)}`,
              ModifiedDate: ` ${feedBack.ItemModifiedBy.properties.defaultDisplay} -  ${new Date(
                feedBack.ItemModified as string
              )
                .toISOString()
                .substring(0, 10)}`,
              Title: feedBack.Title,
              eKey: feedBack.eKey,
              eTag: feedBack.eTag,
            })) || []
          setsiteFeedBackItems(feedbacks)
          setShowPageOverlay(false)
        })
      }
    }
    getFeedBacks()
  }, [siteFeedback])

  const ColumnsToExport: ExportColumns[] = [
    { header: 'Subject', key: 'Title' },
    { header: 'Feedback About', key: 'FeedbackAbout' },
    { header: 'Description', key: 'Description' },
    { header: 'Attachments', key: 'FileNames' },
    { header: 'Modified', key: 'ModifiedDate' },
  ]
  const onDownload = () => {
    exportToExcel('siteFeedBack', ColumnsToExport, siteFeedBackItems)
  }
  return (
    <div className='container'>
      {showPageOverlay && <PageOverlayBusy />}

      <div className='row'>
        <div className='shadow card mt-0 p-3 my-2 mx-2'>
          <SettingsHeader
            extras={
              <Buttons
                aria-label='Download Site Feedback'
                className='btn-sm btn-primary font-0 font-xl-13 ms-auto whitetext text-nowrap border-radius poppins-bold'
                icon='icon-download me-xl-1 font-11'
                label='Download Site Feedback'
                onClick={onDownload}
              />
            }
            name='Site Feedback'
          />
          <div className='p-0 settings-main mt-2'>
            {siteFeedBackItems.length > 0 ? (
              siteFeedBackItems.map((feedback) => (
                <div
                  aria-live='polite'
                  className='d-flex flex-column shadow card poppins-medium mb-2 py-3'
                  key={feedback.Title}
                  tabIndex={0}
                >
                  <div className='d-flex px-2'>
                    <div className='d-flex flex-column flex-md-row flex-wrap w-100'>
                      <div className='d-flex col flex-column me-auto my-2'>
                        <div className='title-color35 poppins-semibold font-12'>Subject</div>
                        <div className='poppins-semibold font-12 title-color2'>
                          {feedback.Title}
                        </div>
                      </div>
                      <div className='dividerdashed vertical m-2 mx-xxl-3 d-none d-md-block my-1'></div>
                      <div className='d-flex flex-column col-md-3 col-lg-2 my-2'>
                        <div className='title-color35 poppins-semibold font-12'>Feedback About</div>
                        <div className='poppins-semibold font-12 title-color2'>
                          {feedback.FeedbackAbout}
                        </div>
                      </div>
                      <div className='dividerdashed vertical m-2 mx-xxl-3 d-none d-md-block my-1'></div>
                      <div className='d-flex flex-column col-md-3 col-lg-2 text-break my-2'>
                        <div className='title-color35 poppins-semibold font-12'>Message</div>
                        <div className='poppins-semibold font-12 title-color2'>
                          {feedback.Description}
                        </div>
                      </div>
                      <div className='dividerdashed vertical m-2 mx-xxl-3 d-none d-md-block my-1'></div>
                      <div className='d-flex flex-column col-md-5 col-lg-2 breakall my-2'>
                        <div className='title-color35 poppins-semibold font-12'>Attachments</div>
                        <div className='poppins-semibold font-12 color-primary'>
                          {feedback?.Attachments[0]?.blobs.length > 0 &&
                            feedback.Attachments[0].blobs.map((blob) => (
                              <a
                                className='color-primary poppins-medium font-12 text-capitalize maxfitcontent'
                                href='#'
                                key={blob.fileName}
                                onClick={() => openFile(blob, feedback.eKey, LIST_NAME)}
                                tabIndex={0}
                                title={blob.fileName}
                              >
                                <div className='color-primary poppins-semibold font-12 color-primary links-over-underline links cursor'>
                                  <span className={`${DocumentIconNames(blob.fileName)} pe-2`}></span>
                                  {blob.fileName}
                                </div>
                              </a>
                            ))}
                        </div>
                      </div>
                      <div className='dividerdashed vertical m-2 mx-xxl-3 d-none d-md-block my-1'></div>
                      <div className='d-flex flex-column col-md-5 col-lg-2 text-break my-2'>
                        <div className='title-color35 poppins-semibold font-12'>Modified</div>
                        <div className='poppins-semibold font-12 title-color2'>
                          {feedback.Modified}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <NO_RESULTS />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default SiteFeedback
